module.exports = __webpack_public_path__ + "img/logo_easy_rent_a_car.99d41aff.png";